export const POST_LIST_WIDGET_BUNDLE_NAME = 'post-list-widget';
